if(!window.__abb){window.__abb=1;(function(){
    if (!('IntersectionObserver' in window)) { document.querySelectorAll('.abb-reveal').forEach(function(e){e.classList.add('is-in')}); return; }
    var io = new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target);} }); }, {threshold:.15});
    function arm(){ document.querySelectorAll('.abb-reveal:not(.is-in)').forEach(function(e){ io.observe(e); }); }
    document.addEventListener('DOMContentLoaded', arm);
    document.addEventListener('shopify:section:load', arm);
  })();}
